// ErrorBoundary.tsx
import { Component } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

interface IErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

// Componente de classe interno
class ErrorBoundaryClass extends Component<
  React.PropsWithChildren<{ navigate: (path: string) => void }>,
  IErrorBoundaryState
> {
  constructor(
    props: React.PropsWithChildren<{ navigate: (path: string) => void }>
  ) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex w-screen h-screen flex-column align-items-center justify-content-center p-5">
          <h2>Algo deu errado.</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
          <Button
            onClick={() => {
              this.props.navigate("/");
              window.location.reload();
            }}
            style={{ marginTop: "20px", padding: "10px" }}
            className="bg-primary"
          >
            Ir para página inicial
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Componente funcional wrapper que usa o hook useNavigate
export function ErrorBoundary({ children }: React.PropsWithChildren<{}>) {
  const navigate = useNavigate();
  return (
    <ErrorBoundaryClass navigate={navigate}>{children}</ErrorBoundaryClass>
  );
}
